// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Library-Discount-DiscountDetail-DiscountForm-__DiscountForm___vUDF3","field-wrapper":"app-pages-Library-Discount-DiscountDetail-DiscountForm-__DiscountForm___1mi0N","footer":"app-pages-Library-Discount-DiscountDetail-DiscountForm-__DiscountForm___3b4Uy","outlet-active":"app-pages-Library-Discount-DiscountDetail-DiscountForm-__DiscountForm___3ienk","outlet-inactive":"app-pages-Library-Discount-DiscountDetail-DiscountForm-__DiscountForm___2bmP-","label-section":"app-pages-Library-Discount-DiscountDetail-DiscountForm-__DiscountForm___pw1fB"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Library/Discount/DiscountDetail/DiscountForm/DiscountForm.css
// module id = 2407
// module chunks = 0